import { forwardRef, useEffect, useImperativeHandle } from "react";
import { Grid } from "@mantine/core";
import { FormValidationResult } from "@mantine/form/lib/types";

import { QuestionnaireFormProvider, QuestionsEditorForm, useQuestionnaireForm } from "../QuestionnaireEditor";
import { useCreateCampaignInquiryFormContext } from "./formContext";

// R10b: the parent inquiry form owns the questionnaire.questions.N.… error keys (R10),
// but the questions/options are actually rendered by this nested QuestionnaireEditor
// form, bound to ITS OWN questions.N.… keys. A parent error alone marks the Dotazník tab
// (R11) but leaves the offending field unmarked, so the nested form's own validate is
// exposed here and run on submit (CreateCampaignInquiry/index.tsx) — the same
// questionnaireFormRef + useImperativeHandle pattern tt-v2-admin-frontend uses
// (CreateCampaignForm/questionnaire.tsx). No frozen test covers this.
export interface CreateCampaignInquiryQuestionnaireFormRef {
    validate(): FormValidationResult;
}

export interface CreateCampaignInquiryQuestionnaireFormProps {
    questionsLimit: number;
}

export const CreateCampaignInquiryQuestionnaireForm = forwardRef<
CreateCampaignInquiryQuestionnaireFormRef,
CreateCampaignInquiryQuestionnaireFormProps
>(({ questionsLimit }: CreateCampaignInquiryQuestionnaireFormProps, ref) => {
    const createCampaignInquiryForm = useCreateCampaignInquiryFormContext();

    const questionnaireForm = useQuestionnaireForm({
        initialValues: createCampaignInquiryForm.values?.questionnaire,
    });

    useImperativeHandle(
        ref,
        () => ({
            validate() {
                return questionnaireForm.validate();
            },
        }),
        [questionnaireForm]
    );

    useEffect(() => {
        createCampaignInquiryForm.setFieldValue("questionnaire", questionnaireForm.values);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [JSON.stringify(questionnaireForm.values)]);

    return (
        <QuestionnaireFormProvider form={questionnaireForm}>
            <Grid>
                <Grid.Col xs={12} sm={12} md={12}>
                    <QuestionsEditorForm customQuestionKeyPrefix=":CUSTOM" questionsLimit={questionsLimit} />
                    {/* <Paper p="lg" shadow="sm" radius="sm" withBorder>
                        <CriteriaEditorForm/>
                    </Paper> */}
                </Grid.Col>
            </Grid>
        </QuestionnaireFormProvider>
    );
});
